import React from 'react';

export const TakeAction = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="80" height="80" rx="40" fill="#BAE1D1" />
    <rect
      x="60"
      y="17"
      width="46"
      height="40"
      rx="10"
      transform="rotate(90 60 17)"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect
      x="53"
      y="27"
      width="26"
      height="26"
      rx="13"
      transform="rotate(90 53 27)"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M33.5 39.5L37.6861 44.1047C38.1084 44.5692 38.8493 44.5343 39.226 44.032L46 35"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
